import { render, staticRenderFns } from "./ProfileConfirmationRow.vue?vue&type=template&id=d35561ee&scoped=true"
import script from "./ProfileConfirmationRow.vue?vue&type=script&lang=ts"
export * from "./ProfileConfirmationRow.vue?vue&type=script&lang=ts"
import style0 from "./ProfileConfirmationRow.vue?vue&type=style&index=0&id=d35561ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35561ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNavigation,VBtn,VCardTitle,VRow,VSpacer})
